export const addressesToTrace = [
  'inj1w2agxn807skfy9aylkpnhpj8jteyjwu6aqatf8',
  '0x72ba834ceff42c9217a4fd833b864792f2493b9a'
]
